// NATIVE 
import * as React from 'react';



// INSTALLED 
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';



// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import MultipleSnackbars from '../../MultipleSnackbars';
import { closeSessionGlobal } from '../../../commons/utils';
import { timeToClosedToast } from '../../../commons/values';
import { CreateTerminal } from '../../terminal/crear/CreateTerminal';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import validationSchema from '../../terminal/formModels/crear/validationSchema';
import formInitialValues from '../../terminal/formModels/crear/formInitialValues';
import createTerminalFormModel from '../../terminal/formModels/crear/createTerminalFormModel';
import { storeCreateTerminal } from '../../../store/terminals';






const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


export const CreateDialogTerminal = (props:any) =>  {

  
  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_terminal, setPercentajeTerminal] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [txtBtnEditTerminal, setTxtBtnEditTerminal] = React.useState<string>('Crear Terminal');

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  // PROPS 
  const{ open, handleCloseModalCrear } = props;

  
  // DATA MODELS 
  const { formId, formField } = createTerminalFormModel;
  const currentValidationSchema = validationSchema[0];


  //  USE EFFECT 
  React.useEffect(() => {
      setIsSubmiting(!open);
  }, [props]);

   
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalCrear(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {


    setTxtBtnEditTerminal('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const response = await dispatch( storeCreateTerminal(values, setPercentajeTerminal) );

   await setTxtBtnEditTerminal('Crear Terminal')

   const result =  await validateResponseCreate(response, ' ( Crear Terminal ) ')

   if ( response.code == 409) {
       setIsSubmiting(false);
   }
   

   if (!result) {
       return false;
   }

   setIsSubmiting(false);


    if (response.ok) {

      const errors:any = {
        msg: 'Terminal Creada Con Exito',
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);


      actions.setSubmitting(false);
      handleCloseModalCrear(false);
    }

  
  }

  const validateResponseCreate = async(response:any, textActionConcat: string) => {
    
    
            if (  response.code == 401  ) {
              await localStorage.removeItem('lastSelectedQypht');
              await closeSessionGlobal();
              await handleCloseModalCrear(false);
              setModalSessionExpired(true);
              return false;
            }
    
         
            // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
            if (!response.ok && response.code == 403 ) { 
    
              const errors:any = {
                  msg: response.errors[0]+' '+textActionConcat,
                  status: 'error'
              };
              
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
              return false;
            }


            // 403 EL DATO YA SE ENCUENTRA REGISTRADO
            if (!response.ok && response.code == 409 ) { 
    
              const errors:any = {
                  msg: response.errors[0]+' '+textActionConcat,
                  status: 'error'
              };
              
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
              return false;
            }
    
            
            // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
            if (!response.ok && response.code == 400 ) { 
       
              const errors:any = [];
    
              response.errors.forEach( (element:any) => {
                  
                  errors.push({
                    type: 'error',
                    text: element
                  });
              });
    
                
              setMessagesAlerts(errors);
              return false;
    
            }
    
            return true;
          
  }

  return (
    <React.Fragment>


      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear Terminal
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <CreateTerminal formField={formField}/>

                <Button
                    disabled={isSubmiting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      txtBtnEditTerminal
                    }
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}